import Container from '@material-ui/core/Container';
import { createStyles, makeStyles } from '@material-ui/core/styles';
// import TextField from '@material-ui/core/TextField';
import React from 'react';
import {
  type AfterPageProps,
  createApiClient,
  createInitialPropsRedirectToLogin,
  makeAfterComponent,
  wrapLayout,
} from '../../@sprinx/react-after-razzle';
import InfoLayout from '../../layouts/InfoLayout/InfoLayout';
import commonThingsToLoad from '../../api/commonThingsToLoad';

export type DownloadsPageProps = AfterPageProps;
export type DownloadsPageClassNameKey = 'root';

const useStyles = makeStyles(() =>
  createStyles<DownloadsPageClassNameKey, {}>({
    root: {},
  }),
);

const DownloadsPage: React.FC<DownloadsPageProps> = () => {
  const classes = useStyles();

  return (
    <>
      <Container>
        <div className={classes.root}>
          <h1>Ke stažení</h1>

          <h2>Zde je místo pro dokumenty a jiné soubory ke stažení.</h2>
        </div>
      </Container>
    </>
  );
};

DownloadsPage.displayName = 'DownloadsPage';

export default makeAfterComponent(
  wrapLayout<DownloadsPageProps>(DownloadsPage, InfoLayout),
  async ({ match, initialAppProps }) => {
    try {
      if (initialAppProps) {
        const appProps = initialAppProps;
        const apiClient = createApiClient({ accessToken: appProps.auth?.accessToken });
        const commonThings = await Promise.all(commonThingsToLoad.promises({ apiClient }));
        appProps.propagateToState({
          ...commonThingsToLoad.toRegister(commonThings),
        });
      }
      return {};
    } catch (error) {
      if (error.response?.status === 401) {
        return createInitialPropsRedirectToLogin({ match });
      }
      return { error };
    }
  },
);
